import FormControl from './FormControl';

export { ControlInputType } from './FormControl';

export default FormControl;
